import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
    fas,
    faCheckToSlot,
    faCircleInfo,
    faGaugeHigh,
    faGears,
    faLocationDot,
    faMapLocationDot,
    faPenToSquare,
    faSignsPost,
    faSquarePlus,
    faTrashCan
} from '@fortawesome/free-solid-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';


@NgModule({ declarations: [AppComponent],
    bootstrap: [AppComponent], imports: [BrowserModule, IonicModule.forRoot(), AppRoutingModule, FontAwesomeModule], providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }, provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class AppModule {
  constructor(library: FaIconLibrary) { 
		library.addIconPacks(fas);
        library.addIcons(
            this.iconAlias(faGaugeHigh, 'tachometer-alt'),
            this.iconAlias(faTrashCan, 'trash-alt'),
            this.iconAlias(faCheckToSlot, 'vote-yea'),
            this.iconAlias(faCircleInfo, 'info-circle'),
            this.iconAlias(faMapLocationDot, 'map-marked-alt'),
            this.iconAlias(faLocationDot, 'map-marker-alt'),
            this.iconAlias(faSignsPost, 'map-signs'),
            this.iconAlias(faGears, 'cogs'),
            this.iconAlias(faPenToSquare, 'edit'),
            this.iconAlias(faSquarePlus, 'plus-square'),
            this.iconAlias(faCircleInfo, 'question-circle')
        );
	}

    private iconAlias(icon: IconDefinition, iconName: string): IconDefinition {
        return { ...icon, iconName } as IconDefinition;
    }

}
